import { render, staticRenderFns } from "./CampaignsOrder.vue?vue&type=template&id=85b07086"
import script from "./CampaignsOrder.vue?vue&type=script&lang=js"
export * from "./CampaignsOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports